import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

const NavigationGuard = ({ children }) => {
  const { isAuthenticated, isLoading, currentUser } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();

  // List of protected routes
  const protectedRoutes = ['/dashboard', '/profile'];
  const isProtectedRoute = protectedRoutes.includes(location.pathname);

  useEffect(() => {
    // Don't do anything while loading
    if (isLoading) {
      return;
    }

    // If authenticated user tries to access login page, redirect to dashboard immediately
    if (location.pathname === '/login' && isAuthenticated) {
      // Check usertype and redirect accordingly
      if (currentUser?.usertype === 'Entity') {
        navigate('/admin/dashboard', { replace: true });
      } else {
        navigate('/dashboard', { replace: true });
      }
      return;
    }
    
    // If trying to access protected route without authentication
    if (isProtectedRoute && !isAuthenticated) {
      navigate('/login', { replace: true });
    }
  }, [isAuthenticated, isLoading, isProtectedRoute, navigate, location.pathname, currentUser]);

  return children;
};

export default NavigationGuard;
